import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserGroupModel } from './model/usergroup.model';
import { UserGroupService } from './usergroup.service';
import { UserComponent } from '../user/user.component';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-usergroup',
  templateUrl: './usergroup.component.html',
  styleUrl: './usergroup.component.scss',
  standalone: false
})
export class UserGroupComponent {

  userGroupList: UserGroupModel[] = [];

  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [
    {
      title: "Code",
      column: "code",
    },
    {
      title: "Name",
      column: "name",
    },
    {
      title: "Description",
      column: "description",
    },

  ];
  displayedColumns = ['code', 'name', 'description', 'action'];
  pagingData = { length: 0, pageSize: 10, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: UserGroupModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<UserGroupModel>(true, []);
  dataSource = new MatTableDataSource(this.userGroupList);
  IsDownloading: boolean = false;
  permission: any;
  userGroupPermission: any;

  constructor(private breakpointObserver: BreakpointObserver,
    private userGroupService: UserGroupService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router, private stateManagerService: StateManagerService,
    public permissionService: PermissionService,
  ) {
    this.permission = permissionService.getPagePermission("user-group");
    this.userGroupPermission = permissionService.getPagePermission("user-group-permission");
    this.userGroupList = [];
  }
  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    // Load data on component initialization
    // this.loadData(); // Removed because loadPreviousState() in ngAfterViewInit inherently calls this
  }
  /** 
   * Set the datasource
   */
  setDataSource(userGroupList: UserGroupModel[]) {
    this.dataSource = new MatTableDataSource(userGroupList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('name', 'asc');
      this.loadData();
    }

  }
  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.userGroupList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.userGroupList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }


  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "is_system")
    ) {
      defFilter.push({
        column: "is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }
  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(userGroup: UserGroupModel): void {
    const id = userGroup.id;
    const message = `Are you sure, you want to delete ` + (userGroup.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      console.log(dialogResult);
      if (dialogResult) {
        this.userGroupService.delete(userGroup).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + userGroup.name + " has been deleted succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.userGroupService.getList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.setDataSource(response.data.user_groups);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.onRowSelected(this.userGroupList[0])
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }

  /**
  * On userGroup selected
  * @param userGroup 
  */
  onRowSelected(userGroup: UserGroupModel): void {
    this.selectedItem = userGroup;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(userGroup: UserGroupModel): void {

    this.router.navigate(['user/user-group-edit', userGroup.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();
  }

  /**
   * On Add clicked
   * Show the dialog to enter new user group
   */
  addClicked(): void {

    this.router.navigate(['user/user-group-edit', 0]);
  }

  /**
 * Handle EPS Permission menu click
 */
  onEPSPermission(userGroup: UserGroupModel): void {
    if (userGroup.id) {
      this.loadPermissions('eps', userGroup.id, userGroup);
    }
  }

  /**
   * Handle POS Permission menu click
   */
  onPOSPermission(userGroup: UserGroupModel): void {
    if (userGroup.id) {
      this.loadPermissions('pos', userGroup.id, userGroup);
    }
  }

  /**
   * Handle OO Permission menu click
   */
  onOOPermission(userGroup: UserGroupModel): void {
    if (userGroup.id) {
      this.loadPermissions('oo', userGroup.id, userGroup);
    }
  }

  /**
   * Handle CRM Permission menu click
   */
  onCRMPermission(userGroup: UserGroupModel): void {
    if (userGroup.id) {
      this.loadPermissions('crm', userGroup.id, userGroup);
    }
  }

  /**
   * Handle WFM Permission menu click
   */
  onWFMPermission(userGroup: UserGroupModel): void {
    if (userGroup.id) {
      this.loadPermissions('wfm', userGroup.id, userGroup);
    }
  }

  /**
   * Handle OSS Permission menu click
   */
  onOSSPermission(userGroup: UserGroupModel): void {
    if (userGroup.id) {
      this.loadPermissions('oss', userGroup.id, userGroup);
    }
  }

  /**
   * Handle CSMS Permission menu click
   */
  onCSMSPermission(userGroup: UserGroupModel): void {
    if (userGroup.id) {
      this.loadPermissions('csms', userGroup.id, userGroup);
    }
  }

  /**
   * Load permissions for the specified app and user group
   * @param app Application name
   * @param userGroupId User group ID
   * @param userGroup User group object for context
   */
  loadPermissions(app: string, userGroupId: number, userGroup: UserGroupModel): void {
    this.isLoading = true;

    this.userGroupService.getPermission(app, userGroupId).subscribe({
      next: (response) => {
        console.log(`${app.toUpperCase()} Permission Response:`, response);
        if (response.status === 'SUCCESS') {
          // Extract permissions array from the nested data structure
          const permissionsArray = response.data.permissions || response.data || [];

          // Store data in sessionStorage for the permissions component to access
          const permissionData = {
            permissions: permissionsArray,
            userGroup: userGroup,
            app: app
          };


          sessionStorage.setItem('usergroup-permissions-data', JSON.stringify(permissionData));

          // Navigate to permission page with only userGroupId and app in query parameters
          this.router.navigate(['user/user-group-permission'], {
            queryParams: {
              app: app,
              userGroupId: userGroupId
            }
          }).then(success => {
            console.log('Navigation success:', success);
            if (success) {
              let snackBarData: SnackBarData = {
                type: 'success',
                title: 'Permissions Loaded',
                message: `${app.toUpperCase()} permissions loaded for ${userGroup.name}`
              };
              // this.snackBarService.openSnackBar(snackBarData);
            } else {
              console.error('Navigation failed - route may not exist');
              let snackBarData: SnackBarData = {
                message: 'Navigation failed. Route may not be configured.',
                title: 'Navigation Error',
                type: 'error'
              };
              this.snackBarService.openSnackBar(snackBarData);
            }
          }).catch(error => {
            console.error('Navigation error:', error);
            let snackBarData: SnackBarData = {
              message: 'Navigation failed: ' + error.message,
              title: 'Navigation Error',
              type: 'error'
            };
            this.snackBarService.openSnackBar(snackBarData);
          });
        } else {
          let snackBarData: SnackBarData = {
            message: response.message || 'Failed to load permissions',
            title: 'Failed to Load Permissions',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        console.error('Error loading permissions:', error);
        let snackBarData: SnackBarData = {
          message: 'Failed to load permissions. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  /**
   * Load system functions for debugging or reference
   * @param app Application name
   */
  loadSystemFunctions(app: string): void {
    this.userGroupService.getSystemFunctions(app).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          console.log(`${app.toUpperCase()} System Functions:`, response.data);
        }
      },
      error: (error) => {
        console.error(`Error loading ${app} system functions:`, error);
      }
    });
  }
  exportClicked() {

  }

}

